import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import { useQuery, gql } from "@apollo/client";

const GET_USER_PROFILE = gql`
  query getUser($userId: ID) {
    user(id: $userId) {
      id
      displayedLoginName
      actualLoginName
      active
      userDemographic {
        id
        firstName
        lastName
        email
        phone
        birthDate
        gender
      }
      customer {
        id
      }
      userPreferences {
        userId
        key
        value
      }
      person {
        id
        relationshipToCustomer
        primaryLocation
        yearsInJob
        personSensitive {
          gender
          birthDate
          streetAddress
          address2
          city
          zipPostal
          stateProv
          country
          currentPosition
          currentPositionStartDate
        }
      }
    }
  }
`;

function useGetUserProfile(userId: string) {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery(GET_USER_PROFILE, {
    variables: {
      userId,
    },
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    profile: result.data?.user
      ? { ...result.data?.user, ...result.data?.user.userDemographic }
      : {},
  };
}

export { useGetUserProfile, GET_USER_PROFILE };
